import * as React from 'react'
import { SVGProps } from 'react'

export const Applestore = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_10633_30959)">
			<path
				d="M0 6C0 2.68629 2.68629 0 6 0H54C57.3137 0 60 2.68629 60 6V54C60 57.3137 57.3137 60 54 60H6C2.68629 60 0 57.3137 0 54V6Z"
				fill="url(#paint0_linear_10633_30959)"
			/>
			<path
				d="M29.7451 13.7846L30.9601 11.6846C31.7101 10.3721 33.3826 9.92962 34.6951 10.6796C36.0076 11.4296 36.4501 13.1021 35.7001 14.4146L23.9926 34.6796H32.4601C35.2051 34.6796 36.7426 37.9046 35.5501 40.1396H10.7251C9.21012 40.1396 7.99512 38.9246 7.99512 37.4096C7.99512 35.8946 9.21012 34.6796 10.7251 34.6796H17.6851L26.5951 19.2371L23.8126 14.4071C23.0626 13.0946 23.5051 11.4371 24.8176 10.6721C26.1301 9.92212 27.7876 10.3646 28.5526 11.6771L29.7451 13.7846ZM19.2151 42.9522L16.5901 47.5047C15.8401 48.8172 14.1676 49.2597 12.8551 48.5097C11.5426 47.7597 11.1001 46.0872 11.8501 44.7747L13.8001 41.3996C16.0051 40.7171 17.7976 41.2422 19.2151 42.9522ZM41.8201 34.6946H48.9226C50.4376 34.6946 51.6526 35.9096 51.6526 37.4246C51.6526 38.9396 50.4376 40.1546 48.9226 40.1546H44.9776L47.6401 44.7747C48.3901 46.0872 47.9476 47.7447 46.6351 48.5097C45.3226 49.2597 43.6651 48.8172 42.9001 47.5047C38.4151 39.7271 35.0476 33.9071 32.8126 30.0296C30.5251 26.0846 32.1601 22.1246 33.7726 20.7821C35.5651 23.8571 38.2426 28.4996 41.8201 34.6946Z"
				fill="white"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_10633_30959"
				x1="30"
				y1="0"
				x2="30"
				y2="60"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#18BFFB" />
				<stop offset="1" stopColor="#2072F3" />
			</linearGradient>
			<clipPath id="clip0_10633_30959">
				<rect width="60" height="60" rx="10" fill="white" />
			</clipPath>
		</defs>
	</svg>
)
